import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import Chart from 'chart.js/auto';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { installStaleBuildRecoveryListeners } from './app/helpers/stale-build-recovery';

if (environment.production) {
  enableProdMode();
}

// Dashboard charts should resize as a batch and must not animate during layout changes.
Chart.defaults.animation = false;
Chart.defaults.resizeDelay = 150;

installStaleBuildRecoveryListeners();

function loadGoogleMaps(): Promise<void> {
  if ((window as any).google?.maps) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const existingScript = document.getElementById('google-maps-api');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve());
      existingScript.addEventListener('error', reject);
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-api';
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleApiKey}&libraries=places&language=en&loading=async`;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

loadGoogleMaps()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch(err => console.error(err));
